export class Therapy {
  public name: string;
  public cost: number;
  public description: string;
  public duration: number;

  constructor (name: string, cost: number, description: string, duration: number) {
    this.name = name;
    this.cost = cost;
    this.description = description;
    this.duration = duration;
  }

  public static getTherapyNames(therapies: Therapy[]): string {
    let therapyNames: string = '';
    therapies.forEach((t, index) => {
      therapyNames += index > 0 ? ', ' : '';
      therapyNames += t.name;
    });
    return therapyNames;
  }

  public static mapFromFirestore(therapy: any): Therapy {
    return new Therapy(
      therapy.name,
      therapy.cost,
      therapy.description,
      therapy.duration
    );
  }

  public mapToFirestore(): any {
    return {
      name: this.name,
      cost: this.cost,
      description: this.description,
      duration: this.duration
    };
  }

  public static mapArrayFromFirestore(therapies: any[]): Therapy[] {
    var therapiesArray = [];
    therapies.forEach((therapy: any) => {
      therapiesArray.push(Therapy.mapFromFirestore(therapy));
    });
    return therapiesArray;
  }

  public static mapArrayToFirestore(therapies: Therapy[]): any {
    var therapiesArray = [];
    therapies.forEach((therapy: Therapy) => {
      therapiesArray.push(therapy.mapToFirestore());
    });
    return therapiesArray;
  }
}
